import { render, staticRenderFns } from "./FormularioConfiguracionPacientes.vue?vue&type=template&id=0342eb65&scoped=true"
import script from "./FormularioConfiguracionPacientes.vue?vue&type=script&lang=js"
export * from "./FormularioConfiguracionPacientes.vue?vue&type=script&lang=js"
import style0 from "./FormularioConfiguracionPacientes.vue?vue&type=style&index=0&id=0342eb65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342eb65",
  null
  
)

export default component.exports